import { render, staticRenderFns } from "./combofund.vue?vue&type=template&id=6d752944&scoped=true"
import script from "./combofund.vue?vue&type=script&lang=js"
export * from "./combofund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d752944",
  null
  
)

export default component.exports